import styled from 'styled-components/macro';

/** @component */
export default styled('button')`
  appearance: none;
  font-weight: 600;
  display: inline-block;
  border-radius: 3px;
  color: ${({ theme }): string => theme.NightBlue};
  transition: ${({ theme }): string =>
    `all ${theme.transitionDuration} ${theme.timingFunction}`};
  padding: ${({ theme }): string =>
    `${theme.spacing.xsmall} ${theme.spacing.small}`};

  @media screen and (min-width: 30em) {
    min-width: 7em;
    padding: ${({ theme }): string =>
      `${theme.spacing.xsmall} ${theme.spacing.medium}`};
  }
`;
